module.exports = __webpack_public_path__ + "static/media/policy_settings_document_categories_add.0d53f6e4.svg";